import styled from "styled-components";


export const CaseInfoContainer = styled.div`
    display: flex;
    flex-direction: column;
    color: #1e1e1e;
    `;

export const PaddingContainer = styled.div`
    padding: 0 28px;
    `;

export const Title = styled.div`
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 1rem;
        color: #1e1e1e;
        `;


export const LinkWrapper = styled.div`
      display: flex;
      gap: 1rem;
      margin: 0px 0.5rem;
`;

export const InfoContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;

export const ApplicantInfoContainer = styled.div`
    display: flex;
    flex-direction: column;
    `;

export const ApplicantName = styled.div`
    margin-top: 1rem;
    margin-left: 0.25rem;
    margin-bottom: 0.5rem;
    font-size: 14px;
    font-weight: 500;
    color: #1e1e1e;
    `;


export const ApplicantNameSpan = styled.span`
    color: #6e7686;
    margin-left: 0.5rem;
    font-weight: 500;
    `;

export const AccountNumberSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    height: fit-content;
`;

export const AccountNumberCard = styled.div`
    background-color: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 6px;
    padding: 12px;
`;

export const AccountNumberLabel = styled.div`
    font-size: 11px;
    font-weight: 500;
    color: #6e7686;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 6px;
`;

export const AccountNumberValue = styled.div`
    font-size: 13px;
    font-weight: 500;
    color: #1e1e1e;
    font-family: 'SF Mono', 'Monaco', 'Inconsolata', 'Roboto Mono', monospace;
    letter-spacing: 0.5px;
`;

export const AccountNumberList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
`;

export const AccountNumberItem = styled.div<{ $isMatch?: boolean }>`
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 10px;
    background-color: ${({ $isMatch }) => $isMatch ? '#e8f5e9' : '#ffffff'};
    border: 1px solid ${({ $isMatch }) => $isMatch ? '#81c784' : '#e9ecef'};
    border-radius: 4px;
`;

export const MatchIndicator = styled.span<{ $isMatch: boolean }>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    font-size: 10px;
    background-color: ${({ $isMatch }) => $isMatch ? '#4caf50' : '#e0e0e0'};
    color: ${({ $isMatch }) => $isMatch ? '#ffffff' : '#9e9e9e'};
`;

export const MismatchBanner = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 8px;
    background-color: #fff3e0;
    border: 1px solid #ffb74d;
    border-radius: 6px;
    padding: 10px 12px;
`;

export const MismatchText = styled.span`
    font-size: 12px;
    color: #e65100;
    font-weight: 500;
    line-height: 1.4;
`;

export const NoAccountText = styled.span`
    font-size: 12px;
    color: #9e9e9e;
    font-style: italic;
`;